import type { WDropDownMenuTranslations } from "./pl";

export const de: WDropDownMenuTranslations = {
  ariaLabelFallback: "Menü",
  empty: "Keine Menüeinträge.",
  seeAll: "alle anzeigen",
  submenuExpand: "Aufklappen",
  submenuCollapse: "Zuklappen",
  submenuToggleLabel: (name, open) =>
    `Untermenü ${open ? "zuklappen" : "aufklappen"}: ${name}`,
  devBanner: {
    prefix: "DEV-only:",
    body:
      "Beispielbaum mit 5-stufiger Verschachtelung. Nur in der Dev-Umgebung sichtbar — Toggle in der Admin-Leiste (Symbol",
    iconLabel: "list-bullets",
    suffix: ") deaktiviert das Einfügen dieses Eintrags.",
    mockL1Name: "DEV: Vollständiger Baum",
  },
};
